import { combineReducers } from 'redux';
import cookieWarning from './cookieWarning.js';
import AppointmentReducer from './AppointmentReducer';
import FormReducer from './FormReducer';
import GetServices from './GetServices';
import GetCabinet from './GetCabinetId';

import mobileAppointmentReducer from './../modules/mobile/reducers/appointment';
import mobileScheduleReducer from './../modules/mobile/reducers/schedule';
import AppointmentPageTextReducer from "./AppointmentPageTextReducer";

let initialState = {};

export default combineReducers({
    AppointmentReducer,
    cookieWarning,
    FormReducer,
    GetServices,
    GetCabinet,
    mobileAppointmentReducer,
    mobileScheduleReducer,
    AppointmentPageTextReducer
});



// WEBPACK FOOTER //
// frontend/src/reducers/rootReducer.js